import * as Yup from 'yup';

export const AssignVehicleSchema = Yup.object().shape({
  driverId: Yup.string().required('Driver name is required'),
  employmentType: Yup.string().required('Employment type is required'),
  plateNumber: Yup.string().required(
    'Vehicle license plate is required',
  ),
});

export interface AssignVehicleDataType {
  driverId: string;
  employmentType: string;
  plateNumber: string;
}

export const AssignVehicleInitialValues: AssignVehicleDataType = {
  driverId: '',
  employmentType: 'Exclusive',
  plateNumber: '',
};

export interface AssignVehicleInterface {
  driverId: string;
  employmentType: string;
  plateNumber: string;
}
